import {FormikProps} from 'formik';
import {ChangeEvent, useMemo} from 'react';

import LikeInputOutlet from '../../../../components/IlikeIputOutlet';
import SelectOutlet from '../../../../components/selectOutlet';

import {ShowFormError} from '../../../../utilities/helper/showFormError';
import {getAmountUnits} from '../../../../utilities/helper/unitGenerator';
import {
  AdvertisementType,
  InputGroupCode,
} from '../../../../utilities/helper/unitGenerator/unit.types';
import {IProductForm} from './productFormData';

interface IProps {
  form: FormikProps<IProductForm>;
}
const WeightInput = ({form}: IProps) => {
  const unitOptions = useMemo(() => {
    return getAmountUnits(
      AdvertisementType.SALE,
      form?.values?.inputGroupCode!,
      form.values.inputCode!,
      form.values?.subInputCode as number,
    ).map((item: any) => ({
      label: item.title,
      value: item.value,
    }));
  }, [form]);

  const toolsUnitDisabledCondition =
    form?.values?.inputGroupCode == InputGroupCode.TOOL &&
    !form?.values?.subInputCode;

  const isWeightDisabled =
    !form?.values?.inputGroupCode ||
    !form?.values?.inputCode ||
    toolsUnitDisabledCondition;

  return (
    <section
      className={`flex flex-col gap-2 ${
        isWeightDisabled && '*:pointer-events-none opacity-50'
      }`}
    >
      <span className="color-gray-1 text-md">
        وزن بسته بندی
        <span className="ml-1 text-red-600">*</span>
      </span>

      <div className="flex gap-2 items-center">
        <div className="w-2/3">
          <LikeInputOutlet
            name="weight"
            label=""
            value={form.values.weight || ''}
            placeholder="وزن بسته بندی را وارد کنید"
            type="number"
            autoComplete="off"
            touched={!!form.values.weight}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              form.setFieldValue('weight', e.target.value);
            }}
          />
        </div>

        <div className="relative w-1/3">
          <span className="absolute right-1 -top-7 z-50 font-medium text-gray-600 text-md">
            واحد
            <span className="ml-1 text-red-600">*</span>
          </span>

          {!form.values.weightUnit && (
            <span className="absolute z-50 font-normal pointer-events-none text-gray-400 text-md top-3.5 right-3">
              واحد
            </span>
          )}

          <SelectOutlet
            label=""
            name="weightUnit"
            value={form.values.weightUnit!}
            options={unitOptions}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              form.setFieldValue('weightUnit', e.target.value);
            }}
          />
        </div>
      </div>

      <div className="flex">
        <ShowFormError field="weight" form={form} className="w-2/3" />

        <ShowFormError field="weightUnit" form={form} className="w-1/3" />
      </div>
    </section>
  );
};

export default WeightInput;
